"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const get_path_segments_1 = require("./get-path-segments");
const is_enumerable_1 = require("./is-enumerable");
const is_object_1 = require("./is-object");
const is_string_1 = require("./is-string");
exports.get = (object, path, defaultValue) => {
    if (!is_object_1.isObject(object) || !is_string_1.isString(path)) {
        return defaultValue;
    }
    const pathSegments = get_path_segments_1.getPathSegments(path);
    for (let i = 0; i < pathSegments.length; i++) {
        if (!is_enumerable_1.isEnumerable(object, pathSegments[i])) {
            return defaultValue;
        }
        object = object[pathSegments[i]];
        if (object === undefined || object === null) {
            /* istanbul ignore else */
            if (i !== pathSegments.length - 1) {
                return defaultValue;
            }
            /* istanbul ignore next */
            break;
        }
    }
    return object;
};
//# sourceMappingURL=get.js.map